/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
/*
 * Author M. Atoar Rahman
 * Title: Pending D2 Table
 * Description: Pending D2 Table
 * Date: 05/06/2022
 */

import moment from 'moment';
import { useCallback, useEffect } from 'react';
import { Badge, Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import useAxiosPrivate from '../../../hooks/useAxiosPrivate';
import useDataTable from '../../../hooks/useDataTable';
import UrlService from '../../../services/UrlService';
import { useD2Approval } from './ContextAPI';

export default function PendingD2Table() {
    const { setShow, setRowData, d2PendingData, getD2PendingData } = useD2Approval();
    const axiosPrivate = useAxiosPrivate();

    const approveHandler = async (row) => {
        try {
            const response = await axiosPrivate.get(UrlService.getD2RecordByIdUrl(row.id), {
                headers: {
                    'Content-Type': 'application/json',
                },
            });

            const row_info = {
                d2_master_id: row.id,
                partner_name: row.partner_name,
                month: row.month,
                year: row.year,
                status: row.status,
                records: response?.data?.d2_record_list,
            };
            setRowData(row_info);
            setShow(true);
        } catch (err) {
            if (!err?.response) {
                console.log('Server Not Responding!');
            } else if (err.response?.status === 401) {
                console.log('Unauthorized!');
            } else {
                console.log('Data Not Found!');
            }
        }
    };

    const dataList = useCallback(() => {
        getD2PendingData();
    }, []);

    useEffect(() => {
        dataList();
    }, [dataList]);

    const columns = [
        {
            name: 'Partner',
            selector: (row) => row.partner_name,
            sortable: true,
            grow: 3,
        },
        {
            name: 'Month',
            selector: (row) => row.month,
            sortable: true,
            cell: (row) =>
                row.month == 1
                    ? 'January'
                    : row.month == 2
                        ? 'February'
                        : row.month == 3
                            ? 'March'
                            : row.month == 4
                                ? 'April'
                                : row.month == 5
                                    ? 'May'
                                    : row.month == 6
                                        ? 'June'
                                        : row.month == 7
                                            ? 'July'
                                            : row.month == 8
                                                ? 'August'
                                                : row.month == 9
                                                    ? 'September'
                                                    : row.month == 10
                                                        ? 'October'
                                                        : row.month == 11
                                                            ? 'November'
                                                            : row.month == 12
                                                                ? 'December'
                                                                : '',
        },
        {
            name: 'Year',
            selector: (row) => row.year,
            sortable: true,
        },
        {
            name: 'Submitted Date',
            selector: (row) => row.submitted_date,
            format: (row) => moment(row.submitted_date).format('DD MMM YYYY'),
            sortable: true,
        },
        {
            name: 'Status',
            sortable: true,
            cell: () => (
                <Badge className="badgeInactive" bg="success">
                    Pending
                </Badge>
            ),
        },
        {
            name: 'Action',
            selector: (row) => row.action,
            cell: (row) => (
                <OverlayTrigger
                    placement="top"
                    overlay={<Tooltip id={`tooltip-approve-${row.id}`}>Approve</Tooltip>}
                >
                    <Button
                        onClick={() => approveHandler(row)}
                        className="btnSuccess"
                        type="button"
                        variant="success"
                    >
                        Approve
                    </Button>
                </OverlayTrigger>
            ),
        },
    ];

    const search_column = {
        partner_name: 'Partner',
        submited_date: 'Submited Date',
    };
    return useDataTable({ columns, data: d2PendingData, search_column, pagination: false });
}
